import { render, staticRenderFns } from "./DataUsage.vue?vue&type=template&id=7217c675&"
import script from "./DataUsage.vue?vue&type=script&lang=js&"
export * from "./DataUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports